export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14409.50d52beb.jpg";